import { Button, Icon } from '@lightspeed/design-system-react'
import React, { FunctionComponent } from 'react'
import { EVENT } from '../../../constants'
import { canRemoveCustomerFromSale } from '../../../functions/sale'
import { useSaleManager } from '../../../ng-compat/hooks'
import { $rootScope } from '../../../ng-compat/imports'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

interface RemoveCustomerProps {
  onCustomerRemoved?: () => void
}

export const RemoveCustomerButton: FunctionComponent<RemoveCustomerProps> = ({
  onCustomerRemoved,
}) => {
  const sale = useAppSelector(selectCurrentSale)
  const saleManager = useSaleManager()

  const handleCustomerRemove = async () => {
    await saleManager.removeCustomer()
    $rootScope.$emit(EVENT.SALE_UPDATE_TENDERED_AMOUNT)
    if (onCustomerRemoved) {
      onCustomerRemoved()
    }
  }

  if (!canRemoveCustomerFromSale(sale)) {
    return null
  }

  return (
    <Button
      variant="no"
      type="button"
      modifier="icon"
      onClick={handleCustomerRemove}
    >
      <Icon icon="fa-trash"></Icon>
    </Button>
  )
}
